import React from 'react';
import { Box, IconButton, Badge } from '@chakra-ui/react';
import { BellIcon } from '@chakra-ui/icons';

export interface NotificationBellProps {
  unreadCount?: number;
  onClick?: () => void;
  isActive?: boolean;
  ariaLabel?: string;
}

/**
 * Notification bell styled with the Mythbound ancient gold + electric glow aesthetic.
 * Compact component for placement in headers or control bars.
 */
export const NotificationBell: React.FC<NotificationBellProps> = ({
  unreadCount = 0,
  onClick,
  isActive = false,
  ariaLabel = 'Notifications',
}) => {
  const hasUnread = unreadCount > 0;

  return (
    <Box position="relative" display="inline-flex" alignItems="center">
      <IconButton
        aria-label={ariaLabel}
        icon={<BellIcon />}
        onClick={onClick}
        variant="ghost"
        size="md"
        _hover={{
          bg: 'rgba(217, 181, 85, 0.15)',
          boxShadow: '0 0 12px rgba(59, 232, 255, 0.6)',
        }}
        _active={{
          bg: 'rgba(217, 181, 85, 0.3)',
        }}
        sx={{
          color: '#f5d58a',
          borderRadius: 'full',
          borderWidth: isActive ? '1px' : '0px',
          borderColor: isActive ? 'rgba(59, 232, 255, 0.8)' : 'transparent',
          transition: 'all 0.2s ease',
        }}
      />
      {hasUnread && (
        <Badge
          position="absolute"
          top="0"
          right="0"
          borderRadius="full"
          bg="rgba(255, 82, 82, 0.95)"
          color="white"
          boxShadow="0 0 8px rgba(255, 82, 82, 0.7)"
          fontSize="0.7rem"
          px={2}
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </Badge>
      )}
    </Box>
  );
};

export default NotificationBell;
